import { produce } from 'immer';
import { createReducer } from 'typesafe-actions';

import type { LeadSummary } from '@evenfinancial/lead-client';

import { nextHydrate } from '../hydrate';
import type { HydrateAction } from '../hydrate';
import { replaceByUuid } from '../utils';

import {
  getLeadByUuidAction,
  getLeadSummariesAction,
  getLeadSummaryByUuidAction,
  getLeadsAction,
  leadSummariesUtilStateChangeAction,
  leadsUtilStateChangeAction,
} from './actions';
import type { LeadAction, LeadState } from './types';

export const leadInitialState: LeadState = {
  leads: {
    byUuid: {},
    error: false,
    loading: false,
    rows: [],
  },
  summaries: {
    error: false,
    loading: false,
    rows: [],
  },
};

export const leadReducer = createReducer<LeadState, LeadAction | HydrateAction>(
  leadInitialState
)
  .handleAction(nextHydrate, (state, { payload }) =>
    produce(state, (draft) => {
      draft.leads = payload.lead.leads;
      draft.summaries = payload.lead.summaries;
    })
  )
  .handleAction(getLeadsAction.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.leads.rows = payload;
    })
  )
  .handleAction(getLeadByUuidAction.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.leads.byUuid = {
        ...state.leads.byUuid,
        [payload.uuid]: payload.lead,
      };
    })
  )
  .handleAction(getLeadSummariesAction.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.summaries.rows = payload;
    })
  )
  .handleAction(getLeadSummaryByUuidAction.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.summaries.rows = replaceByUuid<LeadSummary>(state.summaries.rows, [
        payload,
      ]);
    })
  )
  .handleAction(leadsUtilStateChangeAction, (state, { payload }) =>
    produce(state, (draft) => {
      draft.leads.loading = payload.loading;
      draft.leads.error = payload.error;
    })
  )
  .handleAction(leadSummariesUtilStateChangeAction, (state, { payload }) =>
    produce(state, (draft) => {
      draft.summaries.loading = payload.loading;
      draft.summaries.error = payload.error;
    })
  );
